<template>
<div>
<div class="app_bar">
     Red<span class="alt-color">Ex</span>
</div>

<v-container
    class="container"
>

    <p class="tracking-no">21RC2384972</p>

    <p class="add-nick">ADD NICKNAME</p>
    <p class="expected">Scheduled Delivery<br/>Fri, Nov 30, 2029</p>

   

    <div
        style="height: 40px; max-width: 600px; margin: auto; position: relative; padding-left: 15px; padding-right: 15px;"
    >

        <div
            style="background-color: #009900; height: 2px; width: 66%; position: absolute; top: 19px;"
        >
        </div>

       <div
            style="background-color: #cccccc; height: 2px; width: calc( 34% - 15px); position: absolute; top: 19px; left: 66%;"
        >
        </div>

        <div
            class="small_circle"
        >
        </div>

        <div
            class="small_circle"
            style="left: 33%"
        >
        </div>

        <div
            class="large_circle"
            style="left: calc(66% - 15px)"
        >
        </div>

         <div
            class="small_circle"
            style="left: calc(100% - 25px); background-color: #cccccc;"
        >
        </div>

    </div>

    <p class="in-transit">IN TRANSIT</p>
    <p class="signature">Signature Required</p>

    <div style="height: 40px; max-width: 600px; margin: auto; position: relative; margin-top: 45px;">

        <div
            style="width: 50%; position: absolute; height: 75px; text-align: center"
        >
            <p class="from_label">FROM</p>
            <p class="from">Nappa Valley, CA</p>
        </div>


         <div
            style="left: 50%; width: 50%; position: absolute; height: 75px; text-align: center"
        >
            <p class="to_label">TO</p>
            <p class="to">Phoenix, AZ</p>
        </div>
    </div>

   

</v-container>
</div>
</template>

<script>
export default {
    data() {
        return {
            step: 2,
        }
    },
}
</script>

<style lang="scss" scoped>
.app_bar {
    width: 100%;
    height: 80px;
    background-color: #4D148C;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: white;
    height: 65px;
    padding-top: 15px;
    font-family: futura;
}

.alt-color
{
    color: #ff6600;
}

.small_circle
{
    height: 16px; width: 16px; background-color: #009900; position: absolute; top: 12px; border-radius: 9px;
}

.large_circle
{
    height: 26px; width: 26px; background-color: #009900; position: absolute; top: 7.5px; border-radius: 13px;
}

.container
{
    text-align: center;
    font-family: roboto, sans-serif;
}

.tracking-no
{
    font-size: 15px;
    margin: 15px;
}

.add-nick
{
    font-size: 14px;
    margin: 15px;
    color: #007AB7;
    font-weight: 700;
}

.expected
{
    font-size: 35px;
    margin: 15px;
    color: #58595B;
    font-weight: 300;
    margin-top: 30px;
}

.in-transit
{
    font-size: 14px;
    margin: 15px;
    margin-top: 30px;
    color: #007AB7;
    font-weight: 700;
}

.expected
{
    margin-bottom: 30px;
}

.signature
{
    font-size: 20px;
}

.minor
{
    font-size: 20px;
    margin: 15px;

}

.from_label, .to_label
{
    font-size: 14px;
    color: #58595B;
    font-weight: 700;
    margin-bottom: 15px;
}


</style>